import styled from "styled-components";

const Title = styled.h1`
  margin-top: -10px;
  margin-bottom: 10px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 2.1rem;
  color: black;
  line-height: 2.8rem;
`;

export default Title;
